export const floorPercent = (value: number) => Math.floor(value);

export const floorPercentByThreePercentStep = (value: number) => {
  if (value >= 100) return value;
  const flooredValue = floorPercent(value);
  const remainder = flooredValue % 3;
  return flooredValue - (remainder < 0 ? remainder + 3 : remainder);
};
